/**
 * FAQ Search Module
 * 
 * Busca instantânea de FAQs via MeiliSearch.
 * Debounce de 300ms, abortável, com fallback para WhatsApp.
 * 
 * - Spinner no input durante carregamento
 * - Filtragem por categorias (credor vs geral) baseada na URL
 * - Trim de espaços dentro das tags <mark> de highlight
 */

const FAQ_SEARCH_API = '/api/faq/search';
const DEBOUNCE_MS = 1200;
const MIN_QUERY_LENGTH = 2;
const SEARCH_LIMIT = 8;
const WHATSAPP_URL = 'https://wa.me/551131269188?text=Estou+vindo+do+site+e+preciso+de+ajuda';

let debounceTimer = null;
let currentXhr = null;

/**
 * Coleta os IDs de categoria visíveis no conteúdo padrão renderizado.
 * Usado para filtrar resultados da busca de acordo com a página atual.
 */
function getDefaultCategoryIds() {
  var ids = [];
  $('#faq-default-content [data-category]').each(function () {
    var id = $(this).data('category');
    if (id && ids.indexOf(id) === -1) {
      ids.push(id);
    }
  });
  return ids;
}

/**
 * Detecta o slug do parceiro a partir da URL.
 * Ex: /parceiros/omni → "omni"
 * Retorna string vazia se não for uma página de parceiro.
 */
function getPartnerSlugFromUrl() {
  var match = window.location.pathname.match(/\/parceiros\/([^\/]+)/);
  return match ? match[1] : '';
}

/**
 * Armazena o título e descrição originais do header.
 */
var originalHeaderContent = {
  title: null,
  description: null
};

/**
 * Atualiza o título e descrição do .help-header.
 * Opcionalmente adiciona uma classe ao container.
 */
function updateHeader(title, description, className) {
  var $header = $('.help-header');
  var $headerTitle = $('.help-header-title');
  var $headerDescription = $('.help-header-description');

  // Armazena conteúdo original na primeira vez
  if (!originalHeaderContent.title && $headerTitle.length) {
    originalHeaderContent.title = $headerTitle.html();
  }
  if (!originalHeaderContent.description && $headerDescription.length) {
    originalHeaderContent.description = $headerDescription.html();
  }

  $headerTitle.html(title);
  $headerDescription.html(description);

  // Adiciona classe se fornecida
  if (className) {
    $header.addClass(className);
  }
}

/**
 * Remove espaços em branco desnecessários dentro e ao redor das tags <mark>.
 * Também trata &nbsp; e une tags <mark> adjacentes.
 */
function trimMarkHighlights(html) {
  if (!html) return html;
  // Remove espaços/nbsp dentro do início e fim de <mark>
  html = html.replace(/<mark>(\s|&nbsp;)+/gi, '<mark>');
  html = html.replace(/(\s|&nbsp;)+<\/mark>/gi, '</mark>');
  // Colapsa espaços entre marks adjacentes
  html = html.replace(/<\/mark>(\s|&nbsp;)+<mark>/gi, '</mark> <mark>');
  // Une marks consecutivas
  html = html.replace(/<\/mark><mark>/g, '');
  return html;
}

/**
 * Mapeia metadados das categorias já renderizadas no FAQ padrão.
 */
function getDefaultCategoryMeta() {
  var categoryById = {};
  var categoryOrder = [];

  $('#faq-default-content .accordion > .category-title').each(function () {
    var $title = $(this);
    var categoryId = $title.data('category');

    if (categoryId === undefined || categoryId === null) return;

    var categoryKey = String(categoryId);
    var $icon = $title.find('.category-icon img').first();
    var categoryName = $.trim($title.clone().children().remove().end().text());

    categoryById[categoryKey] = {
      name: categoryName || 'Outras perguntas',
      iconSrc: $icon.attr('src') || '/static/images/ajuda/icons/negociacao.svg',
      iconAlt: $icon.attr('alt') || categoryName || 'Categoria'
    };

    if (categoryOrder.indexOf(categoryKey) === -1) {
      categoryOrder.push(categoryKey);
    }
  });

  return {
    byId: categoryById,
    order: categoryOrder
  };
}

/**
 * Mostra o spinner de loading na área de resultados.
 */
function showLoadingSpinner($results, $defaultContent) {
  $defaultContent.hide();

  var html = '<div class="faq-search-loading">';
  html += '  <div class="faq-search-loading-spinner"></div>';
  html += '  <span class="faq-search-loading-text">Buscando...</span>';
  html += '</div>';

  $results.html(html).show();
}

function setWhatsappFallbackVisible(isVisible) {
  var $fallback = $('#faq-whatsapp-fallback');
  if (!$fallback.length) return;
  $fallback.toggle(!!isVisible);
}

/**
 * Inicializa o módulo de busca de FAQ.
 * Chamado no DOM ready.
 */
function initFaqSearch() {
  var $input = $('#faq-search-input');
  var $results = $('#faq-search-results');
  var $defaultContent = $('#faq-default-content');
  var $clearBtn = $('#faq-search-clear');

  if (!$input.length) return;

  // Estado inicial: botão de WhatsApp oculto.
  setWhatsappFallbackVisible(false);

  // Coleta categorias e parceiro uma vez no init
  var allowedCategoryIds = getDefaultCategoryIds();
  var partnerSlug = getPartnerSlugFromUrl();

  $input.on('input', function () {
    var query = $(this).val().trim();

    // Mostra/esconde botão de limpar
    $clearBtn.toggle(query.length > 0);

    // Cancela request em andamento
    if (currentXhr) {
      currentXhr.abort();
      currentXhr = null;
    }

    clearTimeout(debounceTimer);

    if (query.length < MIN_QUERY_LENGTH) {
      restoreDefaultContent($results, $defaultContent);
      return;
    }

    setWhatsappFallbackVisible(false);
    showLoadingSpinner($results, $defaultContent);

    debounceTimer = setTimeout(function () {
      executeSearch(query, $results, $defaultContent, allowedCategoryIds, partnerSlug);
    }, DEBOUNCE_MS);
  });

  // Botão limpar
  $clearBtn.on('click', function () {
    $input.val('').trigger('input').focus();
  });

  // Previne submit de form (se houver)
  $input.closest('form').on('submit', function (e) {
    e.preventDefault();
  });
}

/**
 * Executa a busca via AJAX.
 * Envia category_ids e partner para filtragem no backend.
 */
function executeSearch(query, $results, $defaultContent, categoryIds, partner) {
  var requestData = {
    q: query,
    limit: SEARCH_LIMIT
  };

  // Envia categorias permitidas para filtro no backend
  if (categoryIds && categoryIds.length > 0) {
    requestData.category_ids = categoryIds.join(',');
  }

  // Envia slug do parceiro para priorização
  if (partner) {
    requestData.partner = partner;
  }

  currentXhr = $.ajax({
    url: FAQ_SEARCH_API,
    method: 'GET',
    data: requestData,
    dataType: 'json',
    timeout: 5000,
    success: function (data) {
      currentXhr = null;
      if (data.hits && data.hits.length > 0) {
        renderResults(data, $results, $defaultContent);
      } else {
        renderNoResults(query, $results, $defaultContent);
      }
    },
    error: function (xhr) {
      currentXhr = null;
      // Ignora aborts (causados por nova digitação)
      if (xhr.statusText === 'abort') return;
      renderError($results, $defaultContent);
    }
  });
}

/**
 * Renderiza os resultados de busca no estilo do accordion existente.
 */
function renderResults(data, $results, $defaultContent) {
  $defaultContent.hide();
  setWhatsappFallbackVisible(false);

  var html = '<div class="accordion" id="accordion-search" itemscope itemtype="https://schema.org/FAQPage">';
  var categoryMeta = getDefaultCategoryMeta();
  var groupedHits = {};
  var groupedOrder = [];

  data.hits.forEach(function (hit) {
    var categoryKey = String(hit.category_id || '0');

    if (!groupedHits[categoryKey]) {
      groupedHits[categoryKey] = [];
      groupedOrder.push(categoryKey);
    }

    groupedHits[categoryKey].push(hit);
  });

  var categoryRenderOrder = categoryMeta.order.filter(function (categoryKey) {
    return !!groupedHits[categoryKey];
  }).concat(groupedOrder.filter(function (categoryKey) {
    return categoryMeta.order.indexOf(categoryKey) === -1;
  }));

  categoryRenderOrder.forEach(function (categoryKey) {
    var currentCategoryMeta = categoryMeta.byId[categoryKey] || {
      name: 'Outras perguntas',
      iconSrc: '/static/images/ajuda/icons/negociacao.svg',
      iconAlt: 'Categoria'
    };

    html += '<h2 class="category-title" data-category="' + categoryKey + '">';
    html += '  <div class="category-icon">';
    html += '    <img src="' + currentCategoryMeta.iconSrc + '" alt="' + escapeHtml(currentCategoryMeta.iconAlt) + '">';
    html += '  </div>';
    html += '  ' + escapeHtml(currentCategoryMeta.name);
    html += '</h2>';

    groupedHits[categoryKey].forEach(function (hit, index) {
    var formatted = hit._formatted || {};
    var question = trimMarkHighlights(formatted.question || hit.question || '');
    var content = trimMarkHighlights(formatted.content || hit.content || '');
    var collapseId = 'collapse-search-' + categoryKey + '-' + hit.id + '-' + index;
    var buttonId = 'btn-colapse-search-' + categoryKey + '-' + hit.id + '-' + index;

    html += '<div class="card card-help" itemscope itemprop="mainEntity" itemtype="https://schema.org/Question" data-category="' + categoryKey + '">';
    html += '  <div class="heading" data-id="' + hit.id + '" data-category="' + categoryKey + '">';
    html += '    <h3 class="mb-0">';
    html += '      <button class="btn btn-link btn-block text-left btn-help collapsed" ';
    html += '        id="' + buttonId + '" type="button" data-toggle="collapse" data-target="#' + collapseId + '" ';
    html += '        aria-expanded="false" itemprop="name">';
    html += '        <span>';
    html += '        ' + question;
    html += '        </span>';
    html += '        <div class="chevron-container">';
    html += '          <i class="fa fa-chevron-right"></i>';
    html += '        </div>';
    html += '      </button>';
    html += '    </h3>';
    html += '  </div>';
    html += '  <div id="' + collapseId + '" class="collapse" data-parent="#accordion-search">';
    html += '    <div class="card-body" id="faq-text-content" itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">';
    html += '      <span itemprop="text">' + content + '</span>';
    html += '    </div>';
    html += '  </div>';
    html += '</div>';
    });
  });

  html += '</div>';

  $results.html(html).show();
}

/**
 * Renderiza o estado de "nenhum resultado" com fallback WhatsApp.
 */
function renderNoResults(query, $results, $defaultContent) {
  $defaultContent.hide();
  $results.hide().empty();
  setWhatsappFallbackVisible(true);

  var title = 'Sua busca por "<strong>' + escapeHtml(query) + '</strong>" não encontrou nenhum resultado.';
  var description = '<p>Tente buscar outros termos ou entre em contato com nosso atendimento.</p>';

  updateHeader(title, description, 'help-header-no-results');
}

/**
 * Renderiza estado de erro com fallback.
 */
function renderError($results, $defaultContent) {
  $defaultContent.hide();
  $results.hide().empty();
  setWhatsappFallbackVisible(true);

  var title = 'Ops! Algo deu errado';
  var description = '<p>Não foi possível buscar no momento. Tente novamente ou consulte as perguntas abaixo.</p>';
  description += '<button class="btn btn-outline-secondary faq-search-restore" type="button">Ver todas as perguntas</button>';

  updateHeader(title, description);

  // Botão para restaurar FAQ original
  $results.on('click', '.faq-search-restore', function () {
    $('#faq-search-input').val('');
    $('#faq-search-clear').hide();
    restoreDefaultContent($results, $defaultContent);
  });
}

// showLoading removido — substituído por showLoadingSpinner

/**
 * Restaura o conteúdo original do FAQ e do header.
 */
function restoreDefaultContent($results, $defaultContent) {
  $results.hide().empty();
  $defaultContent.show();
  setWhatsappFallbackVisible(false);
  $(document).trigger('faq:default:restored');

  // Restaura header original
  if (originalHeaderContent.title) {
    $('.help-header-title').html(originalHeaderContent.title);
  }
  if (originalHeaderContent.description) {
    $('.help-header-description').html(originalHeaderContent.description);
  }

  // Remove classes de estado
  $('.help-header').removeClass('help-header-no-results');
}

/**
 * Escapa HTML para prevenir XSS no texto do usuário.
 */
function escapeHtml(text) {
  var div = document.createElement('div');
  div.appendChild(document.createTextNode(text));
  return div.innerHTML;
}

// Inicializa quando o DOM estiver pronto
$(document).ready(function () {
  initFaqSearch();
});
